import apolloClient from 'store/apolloClient';

import { get } from 'lodash';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { fetchConversation } from 'modules/conference/actions/fetchConversation';
import { currentConversation } from 'modules/appointmentInfo/selectors/currentAppointment';

import createAction from '../';
import * as services from '../../services/updateConversation';


export const UPDATE_CONVERSATION = createAsyncAction(createAction('UPDATE_CONVERSATION'));

export const updateConversation = (status, selectedAppointmentId) => (dispatch, getState) => {
  const state = getState();
  const { conversationId } = currentConversation(state);
  const appointmentId = selectedAppointmentId || state.appointmentInfo.currentAppointment.appointmentId;

  dispatch({ type: UPDATE_CONVERSATION.pending });

  const apiCallParams = {
    mutation: services.UPDATE_CONVERSATION,
    variables: { conversationId, status, appointmentId },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { updateConversation } }) =>
      dispatch({
        type: UPDATE_CONVERSATION.success,
        payload: { conversation: updateConversation },
      }),
    )
    .catch((err) => {
      dispatch(errorAction(UPDATE_CONVERSATION.failure, err));
      const { graphQLErrors = [] } = err;
      const apiErrorCodes = graphQLErrors.map(error => get(error, 'extensions.code'), 500).map(Number);

      if (apiErrorCodes.includes(874)) {
        dispatch(fetchConversation(conversationId));
      }
      throw err;
    });
};
